import { API } from "aws-amplify";
import { GraphQLQuery } from "@aws-amplify/api";
import { setUserHomepageConfig } from "@/graphql/mutations";
import { useMutation } from "@tanstack/react-query";

interface IsetUserDashboardConfig {
  config: string;
  disabledQuickQuestion: boolean;
}

export const useSetUserDashboardConfig = () => {
  return useMutation({
    mutationKey: ["SET_DASHBOARD_CONFIG"],
    mutationFn: async (payload: IsetUserDashboardConfig) => {
      await API.graphql<GraphQLQuery<any>>({
        query: setUserHomepageConfig,
        variables: payload,
      });
    },
  });
};
